
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Facility {
  id: string;
  provider_id: string;
  name: string;
  description: string | null;
  facility_type: string;
  image_url: string | null;
  video_url: string | null;
  created_at: string;
  updated_at: string;
}

export const useFacilities = (providerId: string) => {
  return useQuery({
    queryKey: ['facilities', providerId],
    queryFn: async () => {
      console.log('Fetching facilities for providerId:', providerId);
      
      const { data, error } = await supabase
        .from('facilities')
        .select('*')
        .eq('provider_id', providerId)
        .order('created_at', { ascending: true });

      if (error) {
        console.error('Error fetching facilities:', error);
        throw error;
      }

      console.log('Facilities data returned:', data);
      return data as Facility[];
    },
    enabled: !!providerId,
  });
};
